import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authAPI, saveAuth } from '../api';
import '../App.css';

function LoginPage() {
  const navigate = useNavigate();
  const [mode, setMode] = useState('login');
  const [role, setRole] = useState('acheteur');
  const [step, setStep] = useState(1);
  const [showPass, setShowPass] = useState(false);

  const [loginData, setLoginData] = useState({ phone: '', password: '' });
  const [registerData, setRegisterData] = useState({
    prenom: '', nom: '', phone: '', email: '',
    ville: '', password: '', confirm: '',
    specialite: '', mobile_money: ''
  });

  const [forgotPhone, setForgotPhone] = useState('');
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [apiError, setApiError] = useState('');

  const villes = ['Dakar', 'Thies', 'Saint-Louis', 'Kaolack', 'Ziguinchor', 'Touba', 'Mbour', 'Rufisque', 'Autre'];
  const specialites = ['Automobile', 'Camion / Poids lourd', 'Moto', 'Machine / Engin', 'Multi-categories'];
  const mobileMoneys = ['Wave', 'Orange Money', 'Free Money', 'Expresso'];

  const validate = () => {
    const e = {};
    if (mode === 'login') {
      if (!loginData.phone) e.phone = 'Numero requis';
      if (!loginData.password) e.password = 'Mot de passe requis';
    }
    if (mode === 'register' && step === 1) {
      if (!registerData.prenom) e.prenom = 'Prenom requis';
      if (!registerData.nom) e.nom = 'Nom requis';
      if (!registerData.phone) e.phone = 'Numero requis';
      if (!registerData.ville) e.ville = 'Ville requise';
    }
    if (mode === 'register' && step === 2) {
      if (!registerData.password) e.password = 'Mot de passe requis';
      if (registerData.password !== registerData.confirm) e.confirm = 'Mots de passe differents';
      if (role === 'vendeur' && !registerData.specialite) e.specialite = 'Specialite requise';
      if (role === 'vendeur' && !registerData.mobile_money) e.mobile_money = 'Mobile Money requis';
    }
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    setApiError('');
    try {
      const res = await authAPI.login({
        phone: loginData.phone,
        password: loginData.password
      });
      saveAuth(res.data.token, res.data.user);
      const user = res.data.user;
      if (user.role === 'vendeur') navigate('/vendeur');
      else if (user.role === 'admin') navigate('/admin');
      else navigate('/mon-compte');
    } catch (err) {
      setApiError(err.response?.data?.message || 'Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  const handleRegisterStep1 = (e) => {
    e.preventDefault();
    if (!validate()) return;
    setStep(2);
  };

  const handleRegisterStep2 = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    setApiError('');
    try {
      const res = await authAPI.register({
        prenom: registerData.prenom,
        nom: registerData.nom,
        phone: registerData.phone,
        email: registerData.email,
        ville: registerData.ville,
        password: registerData.password,
        role,
        specialite: registerData.specialite,
        mobile_money: registerData.mobile_money
      });
      saveAuth(res.data.token, res.data.user);
      setSuccess('Compte cree avec succes ! Rak tak !');
      setTimeout(() => navigate(role === 'vendeur' ? '/vendeur' : '/mon-compte'), 1500);
    } catch (err) {
      setApiError(err.response?.data?.message || 'Erreur lors de la creation du compte');
    } finally {
      setLoading(false);
    }
  };

  const inp = (val, err, onChange, placeholder, type = 'text') => (
    <div style={{ position: 'relative' }}>
      <input
        type={type}
        value={val}
        onChange={onChange}
        placeholder={placeholder}
        style={{
          width: '100%', padding: '12px 14px',
          background: err ? 'rgba(239,68,68,.08)' : '#141414',
          border: `1.5px solid ${err ? '#EF4444' : '#333'}`,
          borderRadius: '9px', fontSize: '14px',
          fontFamily: 'Plus Jakarta Sans, sans-serif', color: '#fff',
          outline: 'none'
        }}
      />
      {err && <div style={{ fontSize: '11px', color: '#EF4444', fontWeight: '700', marginTop: '4px' }}>{err}</div>}
    </div>
  );

  return (
    <div className="app" style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <nav className="nav">
        <Link to="/" style={{ textDecoration: 'none' }}>
          <div className="logo-wrap">
            <div className="logo">Tek<span>Teck</span></div>
            <div className="logo-tag">rak tak!</div>
          </div>
        </Link>
        <div style={{ fontSize: '13px', color: '#888' }}>
          {mode === 'login' ? 'Connexion' : mode === 'register' ? 'Creer un compte' : 'Mot de passe oublie'}
        </div>
        <Link to="/"><button className="btn-ghost">← Retour</button></Link>
      </nav>

      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '40px 24px', background: 'radial-gradient(ellipse at 60% 0%, rgba(245,98,10,.06) 0%, transparent 60%)' }}>
        <div style={{ width: '100%', maxWidth: '460px' }}>

          {success && (
            <div style={{ background: 'rgba(34,197,94,.12)', border: '1.5px solid rgba(34,197,94,.3)', borderRadius: '10px', padding: '14px 18px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '20px' }}>✅</span>
              <span style={{ fontSize: '13px', fontWeight: '700', color: '#22C55E' }}>{success}</span>
            </div>
          )}

          {apiError && (
            <div style={{ background: 'rgba(239,68,68,.12)', border: '1.5px solid rgba(239,68,68,.3)', borderRadius: '10px', padding: '14px 18px', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={{ fontSize: '20px' }}>❌</span>
              <span style={{ fontSize: '13px', fontWeight: '700', color: '#EF4444' }}>{apiError}</span>
            </div>
          )}

          <div style={{ background: '#1C1C1C', border: '1px solid #333', borderRadius: '16px', padding: '32px', position: 'relative', overflow: 'hidden' }}>
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '3px', background: 'linear-gradient(90deg, #F5620A, #FF7A2E, transparent)' }}></div>

            {mode !== 'forgot' && (
              <div style={{ display: 'flex', gap: '0', marginBottom: '28px', background: '#141414', borderRadius: '10px', padding: '4px' }}>
                {[['login', '🔐 Se connecter'], ['register', '✨ Creer un compte']].map(([m, label]) => (
                  <button key={m} onClick={() => { setMode(m); setStep(1); setErrors({}); setSuccess(''); setApiError(''); }}
                    style={{ flex: '1', padding: '10px', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: '800', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif', background: mode === m ? '#F5620A' : 'transparent', color: mode === m ? '#fff' : '#888' }}>
                    {label}
                  </button>
                ))}
              </div>
            )}

            {mode === 'login' && (
              <form onSubmit={handleLogin}>
                <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '26px', letterSpacing: '1px', color: '#fff', marginBottom: '6px' }}>BIENVENUE !</div>
                <div style={{ fontSize: '13px', color: '#888', marginBottom: '24px' }}>Connectez-vous pour acceder a votre espace</div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '20px' }}>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', letterSpacing: '.4px', display: 'block', marginBottom: '6px' }}>NUMERO DE TELEPHONE</label>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <div style={{ padding: '12px 14px', background: '#141414', border: '1.5px solid #333', borderRadius: '9px', fontSize: '14px', fontWeight: '700', color: '#fff', whiteSpace: 'nowrap' }}>🇸🇳 +221</div>
                      {inp(loginData.phone, errors.phone, e => setLoginData({ ...loginData, phone: e.target.value }), '7X XXX XX XX', 'tel')}
                    </div>
                  </div>
                  <div>
                    <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', letterSpacing: '.4px', display: 'block', marginBottom: '6px' }}>MOT DE PASSE</label>
                    <div style={{ position: 'relative' }}>
                      {inp(loginData.password, errors.password, e => setLoginData({ ...loginData, password: e.target.value }), 'Votre mot de passe', showPass ? 'text' : 'password')}
                      <button type="button" onClick={() => setShowPass(!showPass)} style={{ position: 'absolute', right: '12px', top: '12px', background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', color: '#888' }}>{showPass ? '🙈' : '👁️'}</button>
                    </div>
                  </div>
                </div>
                <div style={{ textAlign: 'right', marginBottom: '20px' }}>
                  <span onClick={() => { setMode('forgot'); setErrors({}); }} style={{ fontSize: '12px', color: '#F5620A', fontWeight: '700', cursor: 'pointer' }}>Mot de passe oublie ?</span>
                </div>
                <button type="submit" disabled={loading} style={{ width: '100%', padding: '14px', background: loading ? '#333' : '#F5620A', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '800', color: '#fff', cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif', marginBottom: '14px' }}>
                  {loading ? '⏳ Connexion...' : 'Se connecter →'}
                </button>
              </form>
            )}

            {mode === 'register' && (
              <div>
                <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '26px', letterSpacing: '1px', color: '#fff', marginBottom: '6px' }}>
                  {step === 1 ? 'CREER MON COMPTE' : 'SECURITE & PREFERENCES'}
                </div>
                <div style={{ fontSize: '13px', color: '#888', marginBottom: '20px' }}>Etape {step} sur 2</div>
                <div style={{ display: 'flex', gap: '6px', marginBottom: '24px' }}>
                  {[1, 2].map(s => (
                    <div key={s} style={{ flex: 1, height: '4px', borderRadius: '2px', background: step >= s ? '#F5620A' : '#333' }}></div>
                  ))}
                </div>

                {step === 1 && (
                  <form onSubmit={handleRegisterStep1}>
                    <div style={{ marginBottom: '16px' }}>
                      <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', letterSpacing: '.4px', display: 'block', marginBottom: '8px' }}>JE VEUX</label>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        {[['acheteur', '🛒 Acheter'], ['vendeur', '🏪 Vendre']].map(([r, label]) => (
                          <button key={r} type="button" onClick={() => setRole(r)}
                            style={{ flex: '1', padding: '12px', border: `1.5px solid ${role === r ? '#F5620A' : '#333'}`, borderRadius: '9px', background: role === r ? 'rgba(245,98,10,.1)' : '#141414', color: role === r ? '#F5620A' : '#888', fontSize: '13px', fontWeight: '800', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                            {label}
                          </button>
                        ))}
                      </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '20px' }}>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                        <div>
                          <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', display: 'block', marginBottom: '6px' }}>PRENOM ★</label>
                          {inp(registerData.prenom, errors.prenom, e => setRegisterData({ ...registerData, prenom: e.target.value }), 'Prenom')}
                        </div>
                        <div>
                          <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', display: 'block', marginBottom: '6px' }}>NOM ★</label>
                          {inp(registerData.nom, errors.nom, e => setRegisterData({ ...registerData, nom: e.target.value }), 'Nom')}
                        </div>
                      </div>
                      <div>
                        <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', display: 'block', marginBottom: '6px' }}>TELEPHONE ★</label>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          <div style={{ padding: '12px 14px', background: '#141414', border: '1.5px solid #333', borderRadius: '9px', fontSize: '14px', fontWeight: '700', color: '#fff', whiteSpace: 'nowrap' }}>🇸🇳 +221</div>
                          {inp(registerData.phone, errors.phone, e => setRegisterData({ ...registerData, phone: e.target.value }), '7X XXX XX XX', 'tel')}
                        </div>
                      </div>
                      <div>
                        <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', display: 'block', marginBottom: '6px' }}>EMAIL</label>
                        {inp(registerData.email, errors.email, e => setRegisterData({ ...registerData, email: e.target.value }), 'votre@email.com', 'email')}
                      </div>
                      <div>
                        <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', display: 'block', marginBottom: '6px' }}>VILLE ★</label>
                        <select value={registerData.ville} onChange={e => setRegisterData({ ...registerData, ville: e.target.value })}
                          style={{ width: '100%', padding: '12px 14px', background: '#141414', border: `1.5px solid ${errors.ville ? '#EF4444' : '#333'}`, borderRadius: '9px', fontSize: '14px', fontFamily: 'Plus Jakarta Sans, sans-serif', color: registerData.ville ? '#fff' : '#888', outline: 'none' }}>
                          <option value="">Selectionnez votre ville</option>
                          {villes.map(v => <option key={v} value={v}>{v}</option>)}
                        </select>
                        {errors.ville && <div style={{ fontSize: '11px', color: '#EF4444', fontWeight: '700', marginTop: '4px' }}>{errors.ville}</div>}
                      </div>
                    </div>
                    <button type="submit" style={{ width: '100%', padding: '14px', background: '#F5620A', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '800', color: '#fff', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                      Continuer → Etape 2
                    </button>
                  </form>
                )}

                {step === 2 && (
                  <form onSubmit={handleRegisterStep2}>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', marginBottom: '20px' }}>
                      <div>
                        <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', display: 'block', marginBottom: '6px' }}>MOT DE PASSE ★</label>
                        <div style={{ position: 'relative' }}>
                          {inp(registerData.password, errors.password, e => setRegisterData({ ...registerData, password: e.target.value }), 'Minimum 8 caracteres', showPass ? 'text' : 'password')}
                          <button type="button" onClick={() => setShowPass(!showPass)} style={{ position: 'absolute', right: '12px', top: '12px', background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', color: '#888' }}>{showPass ? '🙈' : '👁️'}</button>
                        </div>
                      </div>
                      <div>
                        <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', display: 'block', marginBottom: '6px' }}>CONFIRMER ★</label>
                        {inp(registerData.confirm, errors.confirm, e => setRegisterData({ ...registerData, confirm: e.target.value }), 'Repetez votre mot de passe', 'password')}
                      </div>
                      {role === 'vendeur' && (
                        <>
                          <div>
                            <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', display: 'block', marginBottom: '6px' }}>SPECIALITE ★</label>
                            <select value={registerData.specialite} onChange={e => setRegisterData({ ...registerData, specialite: e.target.value })}
                              style={{ width: '100%', padding: '12px 14px', background: '#141414', border: `1.5px solid ${errors.specialite ? '#EF4444' : '#333'}`, borderRadius: '9px', fontSize: '14px', fontFamily: 'Plus Jakarta Sans, sans-serif', color: registerData.specialite ? '#fff' : '#888', outline: 'none' }}>
                              <option value="">Votre specialite</option>
                              {specialites.map(s => <option key={s} value={s}>{s}</option>)}
                            </select>
                            {errors.specialite && <div style={{ fontSize: '11px', color: '#EF4444', fontWeight: '700', marginTop: '4px' }}>{errors.specialite}</div>}
                          </div>
                          <div>
                            <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', display: 'block', marginBottom: '6px' }}>MOBILE MONEY ★</label>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                              {mobileMoneys.map(mm => (
                                <button key={mm} type="button" onClick={() => setRegisterData({ ...registerData, mobile_money: mm })}
                                  style={{ padding: '10px', border: `1.5px solid ${registerData.mobile_money === mm ? '#F5620A' : '#333'}`, borderRadius: '8px', background: registerData.mobile_money === mm ? 'rgba(245,98,10,.1)' : '#141414', color: registerData.mobile_money === mm ? '#F5620A' : '#888', fontSize: '12px', fontWeight: '700', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                                  📱 {mm}
                                </button>
                              ))}
                            </div>
                            {errors.mobile_money && <div style={{ fontSize: '11px', color: '#EF4444', fontWeight: '700', marginTop: '4px' }}>{errors.mobile_money}</div>}
                          </div>
                        </>
                      )}
                      <label style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', cursor: 'pointer' }}>
                        <input type="checkbox" style={{ marginTop: '3px', accentColor: '#F5620A' }} required />
                        <span style={{ fontSize: '12px', color: '#888', lineHeight: '1.5' }}>
                          J'accepte les <span style={{ color: '#F5620A', fontWeight: '700' }}>CGU</span> de TekTeck.
                        </span>
                      </label>
                    </div>
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <button type="button" onClick={() => setStep(1)} style={{ flex: '1', padding: '14px', background: 'transparent', border: '1.5px solid #333', borderRadius: '10px', fontSize: '14px', fontWeight: '700', color: '#888', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                        ← Retour
                      </button>
                      <button type="submit" disabled={loading} style={{ flex: '2', padding: '14px', background: loading ? '#333' : '#F5620A', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '800', color: '#fff', cursor: loading ? 'not-allowed' : 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                        {loading ? '⏳ Creation...' : role === 'vendeur' ? 'Creer mon espace vendeur' : 'Creer mon compte'}
                      </button>
                    </div>
                  </form>
                )}
              </div>
            )}

            {mode === 'forgot' && (
              <form onSubmit={(e) => { e.preventDefault(); }}>
                <div style={{ fontFamily: 'Bebas Neue, sans-serif', fontSize: '26px', color: '#fff', marginBottom: '6px' }}>MOT DE PASSE OUBLIE</div>
                <div style={{ fontSize: '13px', color: '#888', marginBottom: '24px' }}>Entrez votre numero pour recevoir un code SMS</div>
                <div style={{ marginBottom: '20px' }}>
                  <label style={{ fontSize: '11px', fontWeight: '700', color: '#888', display: 'block', marginBottom: '6px' }}>NUMERO DE TELEPHONE</label>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <div style={{ padding: '12px 14px', background: '#141414', border: '1.5px solid #333', borderRadius: '9px', fontSize: '14px', fontWeight: '700', color: '#fff' }}>🇸🇳 +221</div>
                    {inp(forgotPhone, errors.phone, e => setForgotPhone(e.target.value), '7X XXX XX XX', 'tel')}
                  </div>
                </div>
                <button type="submit" style={{ width: '100%', padding: '14px', background: '#F5620A', border: 'none', borderRadius: '10px', fontSize: '15px', fontWeight: '800', color: '#fff', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif', marginBottom: '12px' }}>
                  📱 Envoyer le code SMS
                </button>
                <button type="button" onClick={() => { setMode('login'); setErrors({}); }} style={{ width: '100%', padding: '11px', background: 'transparent', border: '1.5px solid #333', borderRadius: '10px', fontSize: '13px', fontWeight: '700', color: '#888', cursor: 'pointer', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                  ← Retour a la connexion
                </button>
              </form>
            )}
          </div>

          <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '12px', color: '#888' }}>
            <div style={{ marginBottom: '8px' }}>🛡️ Connexion 100% securisee</div>
            <Link to="/" style={{ color: '#F5620A', fontWeight: '700', textDecoration: 'none' }}>← Retour a l'accueil TekTeck</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;